import { AuthService } from './../../shared/services/auth/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, EventEmitter, Output } from '@angular/core';
import { PayScheduleHistory } from 'src/app/models/pay-schedule.model';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { ScheduleService } from 'src/app/shared/services/pay-schedules/schedule.service';

@Component({
  selector: 'app-schedule-details',
  templateUrl: './schedule-details.component.html',
  styleUrls: ['./schedule-details.component.css']
})
export class ScheduleDetailsComponent implements OnInit, OnChanges {
  todaysDate: Date = new Date();
  cfy: number = this.todaysDate.getFullYear() + (this.todaysDate.getMonth() + 1 > 6 ? 1 : 0);
  config: any;
  operators: any;
  isSchChangesVisible: boolean;
  hideEmpScheduleSection = false;
  msg = '';
  fY = 0;
  @Input() scheduleId = 0;
  @Input() actionType = '';
  @Input() orgName = '';
  @Input() scheduleHistory: PayScheduleHistory;
  @Input() employerSchId;
  @Input()
  set userActionData(action: any) {
    if (action) {
      this.operators = action.operators;
      this.isSchChangesVisible = action.showEmpScheduleChanges;
    }
  }
  @Output() successResult = new EventEmitter();
  schedule: PayScheduleHistory;
  scheduleEntry: any[];
  noScheduleEntryText: any;
  btnDisable: boolean;
  isInputVisible = false;
  empScheduleIdExists: boolean;
  isProcessing = false;
  invalidAlphaNumeric = false;
  inputValidationPattern = /^[A-Za-z0-9]+$/;

  constructor(
    private scheduleService: ScheduleService,
    private readConfigService: ReadConfigService,
    private authService: AuthService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.config = this.readConfigService.getPayScheduleText();
    this.noScheduleEntryText = this.config.NoScheduleEntry;
    document.getElementById('scheduleDetails').scrollIntoView();
    this.authService.formChanged(true);
  }

  ngOnChanges() {
    this.loadSchedule(this.scheduleId);
    document.getElementById('scheduleDetails').scrollIntoView();
  }

  onEmpIdInput(value: any) {
    const empScheduleId = value && value.trim();
    this.invalidAlphaNumeric = (empScheduleId && !this.inputValidationPattern.test(empScheduleId)) ? true : false;
    this.empScheduleIdExists = false;
    this.btnDisable = false;
    this.authService.formChanged(false);
  }

  onEmpIdChange(schedule: any, value: any) {
    const empScheduleId = value.trim();
    if (empScheduleId.length > 0) {
      const obj = {
        userInfo: this.scheduleService.UserInfo(),
        EmployerScheduleID: empScheduleId,
        fiscalYear: schedule.fiscalYear.toString()
      };
      this.scheduleService.empScheduleIdExists(obj)
        .subscribe((response) => {
          if (response) {
            this.empScheduleIdExists = response.isExists;
            if (this.empScheduleIdExists) {
              this.isProcessing = false;
              return;
            } else {
              this.updateEmpId(schedule);
            }
          } else {
            this.notificationService.setErrorNotification();
          }
        },
          (err: HttpErrorResponse) => {
            console.log(err);
            this.notificationService.setErrorNotification();
          });
    }
  }

  updateEmpId(scheduleValues: any) {
    const obj = {
      userInfo: this.scheduleService.UserInfo(),
      EmployerScheduleID: scheduleValues.employerScheduleID,
      msraScheduleId: scheduleValues.id
    };
    this.scheduleService.updateEmpSchId(obj)
      .subscribe((response) => {
        if (response && response.statusCode === 200) {
          const fiscalYear = scheduleValues.fiscalYear;
          this.successResult.emit({ response, fiscalYear });
          this.notificationService.setUpNotification(response);
          this.isInputVisible = true;
          this.btnDisable = true;
        } else {
          this.notificationService.setErrorNotification();
        }
        this.isProcessing = false;
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.isProcessing = false;
          this.notificationService.setErrorNotification();
        });
  }

  onSaveClick(scheduleValues: any, value: any) {
    this.isProcessing = true;
    this.onEmpIdChange(scheduleValues, value);
  }

  editClick() {
    this.isInputVisible = false;
  }

  cancelClick() {
    this.scheduleHistory.employerScheduleID = this.employerSchId;
    this.isInputVisible = true;
    this.btnDisable = true;
    this.empScheduleIdExists = false;
  }

  loadSchedule(id: number): void {
    this.empScheduleIdExists = false;
    this.invalidAlphaNumeric = false;
    this.btnDisable = true;
    this.scheduleHistory.employerScheduleID = this.employerSchId;
    this.notificationService.setUpLoading(true);
    const obj = { userInfo: this.scheduleService.UserInfo(), id };
    this.scheduleService.getScheduleEntries(obj).subscribe(response => {
      if (response && response.success) {
        this.isInputVisible = true;
        this.schedule = this.scheduleHistory;
        this.scheduleEntry = response.message;
      }
      this.notificationService.setUpLoading(false);
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.setUpLoading(false);
      });
  }
  print(): void {
    const details = document.getElementById('print-section1');
    const schedules = document.getElementById('print-section2');
    if (details && schedules) {
      const printdetails = details.innerHTML;
      const printschedules = schedules.innerHTML;
      const popupWin = window.open('', '_blank', 'width=880,height=600,toolbar=0,scrollbars=1,resizable=1');
      popupWin.document.open();
      popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>table.printTable tbody tr td, th {border-bottom: solid 1px rgb(220,220,220); padding-right:14px;align-items:left}
                    #scheduleInfo div.col { display: inline-flex } .for-print {display: block} .padding-for-print{padding-left: 5px}
                     .bold {font-weight: 700} table.printTable2 tbody tr td, th {border-bottom: solid 1px rgb(220,220,220);}
                    @page { size: auto;  margin: 0mm 0mm 10mm 0mm; padding-top:15mm }
                    table.printTable th,td{    color: #555;padding-left: 0.25em;padding-right: 10px;}
                    table.printTable1 th{display: flex;}
                    .printTable2{text-align:center;}
                    .printhidden{display:none;}
                    table{border-spacing:0;border-bottom:solid 1px black} input, button.k-button{display:none;}</style>
        </head>
        <body onload="window.print();window.close()" style="margin: 10mm 15mm 10mm 15mm;">
            <div>${printdetails}</div>
            <div>${printschedules}</div>
            <br/><button OnClick="window.print();">Print</button>
            </body>
      </html>`
      );
    }
  }
}
